import { Button, Spinner } from 'react-bootstrap';
import moment from 'moment';

export interface DashboardToolbarProps {
  onAddTile: () => void;
  onSave: () => void;
  onPickDateRange: () => void;
  onRefreshData: () => void;
  onClearDateRange: () => void;
  
  hasAnyTiles: boolean;
  startDate?: number | null;
  endDate?: number | null;
  isLoading?: boolean;
  isSaving?: boolean;
  isLoadingData?: boolean;
}

/**
 * Toolbar component with buttons for dashboard operations.
 * Allows user to add tiles, save layout, picker date ranges, etc.
 */
export function DashboardToolbar({
  onAddTile,
  onSave,
  onPickDateRange,
  onRefreshData,
  onClearDateRange,
  hasAnyTiles,
  startDate,
  endDate,
  isLoading = false,
  isSaving = false,
  isLoadingData = false,
}: DashboardToolbarProps) {
  return (
    <div className="mb-4 d-flex justify-content-between">
      <div>
        <Button
          onClick={onPickDateRange}
          variant="outline-primary"
          title="Pick a different date range..."
          disabled={!hasAnyTiles || isLoadingData}
          className="mx-2"
        >
          <i className="bi bi-calendar-event"></i>
        </Button>
        {startDate && endDate && (
          <Button variant="outline-danger" style={{ pointerEvents: 'none' }} className="mx-2">
            {`Range: ${moment(new Date(startDate * 1000)).format('DD/MM/YY, hh:mm')} - ${moment(new Date(endDate * 1000)).format('DD/MM/YY, hh:mm')}`}
            <span
              onClick={onClearDateRange}
              style={{ pointerEvents: 'auto', display: 'inline-block', marginLeft: '10px' }}
            >
              <i className="bi bi-x-lg"></i>
            </span>
          </Button>
        )}
      </div>
      <div>
        <Button
          onClick={onSave}
          variant="outline-danger"
          className="mx-2"
          title="Save dashboard layout"
          disabled={isSaving || !hasAnyTiles}
        >
          {isSaving ? (
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          ) : (
            <i className="bi bi-floppy"></i>
          )}
        </Button>
        <Button
          className="mx-2"
          variant="outline-primary"
          onClick={onAddTile}
          disabled={isLoading || isLoadingData}
        >
          + Add a new tile
        </Button>
        <Button
          disabled={isLoadingData}
          onClick={onRefreshData}
          variant="outline-secondary"
          title="Refresh tile data"
        >
          {isLoadingData ? (
            <Spinner as="span" animation="border" size="sm" role="status" />
          ) : (
            <i className="bi bi-arrow-clockwise"></i>
          )}
        </Button>
      </div>
    </div>
  );
}
